<template>
  <header id="header" class="header fixed-top d-flex align-items-center"
    style="z-index: 9999 !important;box-shadow:none;">
    <!-- background: linear-gradient(90deg,#1c3643,#273b47 25%,#1e5372); -->
    <div class="d-flex align-items-center justify-content-between">
      <svg @click="toggleBodyClass()" class="toggle-sidebar-btn" xmlns="http://www.w3.org/2000/svg" width="35" height="35"
        viewBox="0 0 24 24" style="fill: #fff;">
        <path d="M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z"></path>
      </svg>

      <router-link to="/" class="logo d-flex align-items-center ms-2">
        <span class="d-none d-lg-block  text-white " style="font-size: 18px;">
          <img src="../assets/img/conf/2.png" alt="">tulcan</span>
      </router-link>
      <div class="search-bar" style="min-width: 280px;">
        <span class="color-header text-sm ms-2 gordo4 s-cursor" @click="isVideo = true">Capacitación</span>
        <a class="color-header text-sm ms-4" href="javascript:;" style="font-weight: 500" @click="isTema = true">
          Temas
          <span class="live-button_decoration__KA3tm ms-2"></span>
        </a>
      </div>
    </div><!-- End Logo -->
    <div class="search-bar">
      <div class="search-form d-flex align-items-center">
        <input class="opacoinp" v-on:click="greet" v-model="texto" type="text" name="query"
          placeholder="Emprezar a escribir..." style="border-radius: 17px; background-color: rgba(255, 255, 255, 0.2) !important;color: rgba(255, 255, 255, 0.95) !important;
           border: 1px solid rgba(255, 255, 255, 0.4) !important;">
        <button v-on:click="greet" type="submit" title="Search">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: #fff">
            <path
              d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z">
            </path>
          </svg>
        </button>
      </div>
    </div><!-- End Search Bar -->
    <nav class="header-nav ms-auto">
      <ul class="d-flex align-items-center">
        <li class="nav-item d-block d-lg-none">
          <a class="nav-link nav-icon search-bar-toggle ">
            <i class="bi bi-search "></i>
          </a>
        </li>
        <li class="nav-item dropdown">
          <router-link to="/idiaoma">
            <img src="../assets/img/new/mipa.svg" alt="" class="me-3" />
          </router-link>
        </li>
        <li >
          <button @click="ifHomePro = true" class="btn btn-base2 btn-azul me-3" style="background-color: #eba51c !important; height: 34px !important;border-radius: 30px !important;margin-bottom: 0px !important;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              style="fill: #fff;transform: ;msFilter:;">
              <path
                d="M20.92 2.38A15.72 15.72 0 0 0 17.5 2a8.26 8.26 0 0 0-6 2.06Q9.89 5.67 8.31 7.27c-1.21-.13-4.08-.2-6 1.74a1 1 0 0 0 0 1.41l11.3 11.32a1 1 0 0 0 1.41 0c1.95-2 1.89-4.82 1.77-6l3.21-3.2c3.19-3.19 1.74-9.18 1.68-9.43a1 1 0 0 0-.76-.73zm-2.36 8.75L15 14.67a1 1 0 0 0-.27.9 6.81 6.81 0 0 1-.54 3.94L4.52 9.82a6.67 6.67 0 0 1 4-.5A1 1 0 0 0 9.39 9s1.4-1.45 3.51-3.56A6.61 6.61 0 0 1 17.5 4a14.51 14.51 0 0 1 2.33.2c.24 1.43.62 5.04-1.27 6.93z">
              </path>
              <circle cx="15.73" cy="8.3" r="2"></circle>
              <path d="M5 16c-2 1-2 5-2 5a7.81 7.81 0 0 0 5-2z"></path>
            </svg>
            Actualizar</button>
        </li>
        <li class="nav-item dropdown">
          <svg @click="ifConfig = true" version="1.1" id="Layer_1" width="26" height="26"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;cursor: pointer;" xml:space="preserve">
            <g class="Bell-body">
              <path id="campanita2" class="Bell-clapper" style="fill:white"
                d="M12.9,18.9c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9H9.7c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3H12.9z"></path>
              <path id="camapanita1" style="fill:white"
                d="M19.2,14.7c-0.6-0.6-1.2-1.2-1.2-4.1c0-3-2.2-5.4-5-5.9c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.6-0.5-1.1-1.1-1.1S10.9,3.4,10.9,4c0,0.2,0.1,0.5,0.2,0.6c-2.8,0.5-5,2.9-5,5.9c0,2.9-0.6,3.5-1.2,4.1 c-1.7,1.7-0.5,4.2,1.6,4.2h3.3h4.6h3.3C19.7,18.9,20.9,16.4,19.2,14.7z M17.6,17.1H6.4c-0.6,0-0.9-0.7-0.5-1.1c1-1,1.8-2,1.8-5.5 c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2c0,3.5,0.8,4.4,1.8,5.5C18.5,16.4,18.2,17.1,17.6,17.1z">
              </path>
            </g>
            <circle style="fill:#FF4842" cx="17" cy="7" r="5"></circle>
          </svg>
        </li><!-- End Messages Nav -->

        <li class="nav-item dropdown pe-3">
          <a class="nav-link nav-profile d-flex align-items-center pe-0" href="javascript:;" data-bs-toggle="dropdown">
            <span class="d-none d-md-block dropdown-toggle ps-2 text-white">{{
              $store.getters.user.name?.toString().slice(0, 1) }}.
              {{ $store.getters.user.name?.toString().split(' ')[2] }}</span>
            <img id="foo" :src="$store.state.avatar" alt="Profile" class="rounded-circle ms-2" @error="standby()">
          </a>
          <!-- <div class="altural"></div> -->
          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li class="dropdown-header borde-menu" style="text-align: left;">
              <p class="text-smm s-color-tres">{{ $store.getters.user.name }}</p>
              <button class="btn btn-base4 btn-verde w-100" @click="ifHomePro = true">Ver mi perfil</button>
            </li>
            <li class="borde-menu">
              <a class="dropdown-item d-flex align-items-center s-color-dos" href="javascript:;" @click="ifConfig = true">
                <i class="bi bi-file-bar-graph"></i>
                <span>Buscas ayuda?</span>
              </a>
              <a class="dropdown-item d-flex align-items-center s-color-dos" href="javascript:;" v-on:click="rendimiento">
                <i class="bi bi-file-bar-graph"></i>
                <span>Rendimiento de sistema</span>
              </a>
            </li>
            <li class="px-3">
              <button class="w-100 btn btn-base4 btn-btz mt-2" @click="isTema = true">Personalizar plataforma</button>
            </li>
            <hr>
            <li class="px-3 mb-2">
              <button class="w-100 btn btn-base4 btn-rojo" @click="logout">
                Finalizar la sesión
              </button>
              <br>
            </li>
          </ul>
        </li>
      </ul>
      <section v-if="ifHomePro">
        <Suspense>
          <template #default>
            <HomeProfile @close="ifHomePro = false" />
          </template>
          <template #fallback>
            <ProgressBar />
          </template>
        </Suspense>
      </section>
      <section v-if="ifConfig">
        <Suspense>
          <template #default>
            <ConfigView @close="ifConfig = false" />
          </template>
          <template #fallback>
            <ProgressBar />
          </template>
        </Suspense>
      </section>
      <section v-if="isVideo">
        <Suspense>
          <template #default>
            <HomeVideo @closed="isVideo = false" />
          </template>
          <template #fallback>
            <ProgressBar />
          </template>
        </Suspense>
      </section>
    </nav>
  </header>
  <section v-if="isDevs">
    <Suspense>
      <template #default>
        <Developers @closed="isDevs = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
  <section v-if="isTema">
    <Suspense>
      <template #default>
        <Temas @closed="isTema = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import ProgressBar from '@/shared/ProgressBar.vue';
export default {
  name: "Inicio",
  data() {
    return {
      ifSeach: false,
      texto: '',
      ifConfig: false,
      ifMode: 0,
      ifHomePro: false,
      isVideo: false,
      isDevs: false,
      isTema: false,
    };
  },
  components: {
    ProgressBar,
    ConfigView: defineAsyncComponent(() =>
      import('../modules/cuenta/views/ConfigView.vue')
    ),
    HomeProfile: defineAsyncComponent(() =>
      import('../modules/cuenta/HomeProfile.vue')
    ),
    HomeVideo: defineAsyncComponent(() =>
      import('../modules/videos/HomeVideo.vue')
    ),
    Developers: defineAsyncComponent(() =>
      import('../modules/integraciones/Developers.vue')
    ),
    Temas: defineAsyncComponent(() =>
      import('../modules/integraciones/Temas.vue')
    ),
  },
  methods: {
    rendimiento() {
      alert('Disponible para usuarios premium')
    },
    greet() {
      this.ifSeach = true;
    },
    toggleBodyClass() {
      const el = document.body;
      if (!el.classList.contains('toggle-sidebar')) {
        el.classList.add('toggle-sidebar');
      } else {
        el.classList.remove('toggle-sidebar');
      }
    },
    logout() {
      const theme = localStorage.getItem('theme');
      localStorage.clear();
      this.$parent.isLoggedIn = false;
      this.$router.push("/").catch(() => { });
      localStorage.setItem("theme", theme);
    },
    initilaSetup() {
      const avatar = JSON.parse(localStorage.getItem('Avatar'));
      let img = avatar;
      this.$store.commit('agregar2', { img })

      let estado;
      if (screen.width <= 800) estado = true;
      else estado = false;
      this.$store.commit('updatepx', { estado })
    },
    temas() {
      try {
        const theme = localStorage.getItem('theme');
        if (theme != null) {
          if (theme != '') {
            document.body.className = theme
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    standby() {
      document.getElementById('foo').src = 'https://res.cloudinary.com/dnnwjfm9m/image/upload/v1695077644/avatar_default_ajfkhn_bjrofo.webp'
    }
  },
  created() {
    this.initilaSetup();
  },
  mounted() {
    this.temas();
  }
};
</script>
<style>
.live-button_decoration__KA3tm {
  position: relative;
  display: inline-block;
  height: 0.625rem;
  width: 0.625rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(233 53 65/1);
}

.live-button_decoration__KA3tm:before {
  -webkit-animation: live-button_pulse__tBFnK 2s ease-out infinite;
  animation: live-button_pulse__tBFnK 2s ease-out infinite;
}

.live-button_decoration__KA3tm:after,
.live-button_decoration__KA3tm:before {
  content: "";
  z-index: -1;
}

.live-button_decoration__KA3tm:after,
.live-button_decoration__KA3tm:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(233 53 65/1);
  opacity: .7;
}

.live-button_decoration__KA3tm:after {
  -webkit-animation: live-button_pulse__tBFnK 2s ease-out 1s infinite;
  animation: live-button_pulse__tBFnK 2s ease-out 1s infinite;
}

.live-button_decoration__KA3tm:after,
.live-button_decoration__KA3tm:before {
  content: "";
  z-index: -1;
}

@keyframes live-button_pulse__tBFnK {
  0% {
    box-shadow: 0 0 0 0px #f28799;
  }

  100% {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
  }
}</style>